import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'src/app/hooks';
import { useTheme } from '@mui/material/styles';
import BottomHeader from './Bottom';
import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import useQueryUrl from 'src/hooks/useQuery';
import EditIcon from '@mui/icons-material/Edit';
import GroupCampaignRetail from '../../GroupCampaignRetail';
import ModalManageObjectRetail from '../../ModalManageObjectRetail';
import ObjectPreviewRetail from '../../ObjectPreviewRetail';
import { TableView, Widgets } from '@mui/icons-material';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: #fbfbfb;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);
const HeaderWrapperSec = styled(Box)(
  ({ theme }) => `
    background: #F5F5F5;
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    justify-content: space-between;
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderSocialMediaHashtagRetail() {
  const { pathname } = useLocation();
  const title = pathname.split('/')[2];
  const query = useQueryUrl();
  const tabQuery = query.get('tab');
  const navigate = useNavigate();
  const [tab, setTab] = useState<string>(tabQuery);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

  const campaignSelected = useAppSelector(
    (state) => state.storeSocialMediaCampaign.campaignSelected
  );

  const objectListByObjectType = useAppSelector(
    (state) => state.objectManagement.objectListByObjectType
  );

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
    navigate(`${pathname}?tab=${newValue}`);
  };
  useEffect(() => {
    setTab(tabQuery);
  }, [tabQuery]);

  const handlePreference = () => {
    if (!campaignSelected) return;

    navigate(`${pathname}?preferences=${campaignSelected.id}`);
  };

  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <HeaderWrapper display="flex" alignItems="center">
        <Grid container>
          <Grid item sm={12}>
            <Stack
              direction={isLargeScreen ? 'row' : 'column'}
              justifyContent="space-between"
              alignItems={isLargeScreen ? 'center' : 'unset'}
              gap={isLargeScreen ? 2 : 1}
              mt={2}
            >
              <Stack
                spacing={1}
                direction="row"
                width={isLargeScreen ? '75%' : '100%'}
                maxWidth={isLargeScreen ? '600px' : 'unset'}
                alignItems="center"
              >
                <GroupCampaignRetail />
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: '16px',
                    height: theme.spacing(5),
                    minWidth: theme.spacing(6)
                  }}
                  onClick={() => {
                    handlePreference();
                  }}
                  color="primary"
                  endIcon={<EditIcon />}
                  disabled={
                    !campaignSelected || campaignSelected.id === '_default'
                  }
                >
                  Preferences
                </Button>
              </Stack>
              <Box>
                <Button
                  variant="outlined"
                  sx={{
                    borderRadius: '16px',
                    height: theme.spacing(5),
                    minWidth: theme.spacing(6),
                    background: theme.palette.common.white
                  }}
                  onClick={() => {
                    navigate(`${pathname}?history=1`);
                  }}
                >
                  Campaign History
                </Button>
              </Box>
            </Stack>
          </Grid>
          <Grid item sm={12}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack
                direction={matchesUpSm ? 'row' : 'column'}
                alignItems={matchesUpSm ? 'center' : 'start'}
                spacing={1}
                mt={1.5}
                mb={2.1}
              >
                <ModalManageObjectRetail title="Social Profile" isCampaign />
                <ObjectPreviewRetail objectList={objectListByObjectType} />
              </Stack>
              <Stack
                sx={{
                  borderRadius: '16px',
                  padding: 1,
                  backgroundColor: theme.colors.primary.lighter
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    sx={{
                      backgroundColor:
                        tab === 'widget' || !tab
                          ? theme.colors.primary.main
                          : theme.colors.primary.lighter,
                      py: 1,
                      px: 2,
                      borderRadius: '16px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleChange(null, 'widget')}
                  >
                    <Widgets
                      sx={{
                        color: tab === 'widget' || !tab ? 'white' : '#757575',
                        fontSize: '16px'
                      }}
                    />
                    <Typography
                      fontWeight={600}
                      fontSize="14px"
                      color={tab === 'widget' || !tab ? 'white' : '#757575'}
                    >
                      Widget
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    sx={{
                      backgroundColor:
                        tab === 'stream_preview'
                          ? theme.colors.primary.main
                          : theme.colors.primary.lighter,
                      py: 1,
                      px: 2,
                      borderRadius: '16px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleChange(null, 'stream_preview')}
                  >
                    <TableView
                      sx={{
                        color: tab === 'stream_preview' ? 'white' : '#757575',
                        fontSize: '16px'
                      }}
                    />
                    <Typography
                      fontWeight={600}
                      fontSize="14px"
                      color={tab === 'stream_preview' ? 'white' : '#757575'}
                    >
                      Stream Preview
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </HeaderWrapper>
      <HeaderWrapperSec display="flex" alignItems="center">
        <Grid container>
          <Grid item sm={12}>
            <BottomHeader key={title} />
          </Grid>
        </Grid>
      </HeaderWrapperSec>
    </>
  );
}

export default HeaderSocialMediaHashtagRetail;
